<div class="container-fluid">

  <div class="report-header">
      <span class="page-header">{{ 'bikeshop.menu.rentals_service_indicator_dashboard' | translate }}</span>
      <div class="report-actions">
        <div class="search-container">
          <input 
            type="text" 
            pInputText
            [(ngModel)]="searchTerm" 
            (input)="search()" 
            placeholder="{{ 'bikeshop.rentals.service_indicator_status_report.search_products' | translate }}" 
            class="search-input"
          >
        </div>
        <div class="filter-container">
          <p-dropdown 
            id="product-filter" 
            [showClear]="true"          
            [(ngModel)]="selectedProduct" 
            (onChange)="filterByProduct($event.value)" 
            [options]="uniqueProducts" 
            [placeholder]="'bikeshop.rentals.service_indicator_status_report.all_products' | translate" 
            class="product-filter"></p-dropdown>
        </div>
      </div>
    </div>
  
  <div class="content service-report-container">  
      <!-- Summary Blocks -->
      <div class="summary-blocks">
        <div 
          class="summary-block" 
          [class.active]="activeStatusFilter === 'all'"
          (click)="filterByStatus('all')"
        >
          <div class="summary-count">{{ totalProducts }}</div>
          <div class="summary-label">{{ 'bikeshop.rentals.service_indicator_status_report.total_products' | translate }}</div>
        </div>
        <div 
          class="summary-block healthy" 
          [class.active]="activeStatusFilter === 'healthy'"
          (click)="filterByStatus('healthy')"
        >
          <div class="summary-count">{{ healthyProducts }}</div>
          <div class="summary-label">{{ 'bikeshop.rentals.service_indicator_status_report.healthy' | translate }}</div>
        </div>
        <div 
          class="summary-block approaching" 
          [class.active]="activeStatusFilter === 'approaching'"
          (click)="filterByStatus('approaching')"
        >
          <div class="summary-count">{{ approachingServiceProducts }}</div>
          <div class="summary-label">{{ 'bikeshop.rentals.service_indicator_status_report.approaching_service' | translate }}</div>
        </div>
        <div 
          class="summary-block needs-service" 
          [class.active]="activeStatusFilter === 'needsService'"
          (click)="filterByStatus('needsService')"
        >
          <div class="summary-count">{{ needsServiceProducts }}</div>
          <div class="summary-label">{{ 'bikeshop.rentals.service_indicator_status_report.needs_service' | translate }}</div>
        </div>
      </div>
    
      <div class="report-content">
        <table class="service-table">
          <thead>
            <tr>
              <th (click)="sort('brand')" style="padding-left: 16px;">
                {{ 'bikeshop.rentals.products.product_tab' | translate }}
                <span *ngIf="sortColumn === 'brand'" class="sort-icon">
                  {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
              </th>
              <th (click)="sort('size')">
                {{ 'bikeshop.rentals.products.size' | translate }}
                <span *ngIf="sortColumn === 'size'" class="sort-icon">
                  {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
              </th>
              <th (click)="sort('serialNumber')">
                {{ 'bikeshop.rentals.products.serial_number' | translate }}
                <span *ngIf="sortColumn === 'serialNumber'" class="sort-icon">
                  {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
              </th>
              <th (click)="sort('serviceIndicatorName')">
                {{ 'bikeshop.rentals.service_indicator_status_report.service_indicator' | translate }}
                <span *ngIf="sortColumn === 'serviceIndicatorName'" class="sort-icon">
                  {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
              </th>
              <th (click)="sort('component')">
                {{ 'bikeshop.rentals.service_indicator_status_report.component' | translate }}
                <span *ngIf="sortColumn === 'component'" class="sort-icon">
                  {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
              </th>
              <th (click)="sort('metric')">
                {{ 'bikeshop.rentals.service_indicator_status_report.metric' | translate }}
                <span *ngIf="sortColumn === 'metric'" class="sort-icon">
                  {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
              </th>
              <th (click)="sort('serviceStatus')">
                {{ 'bikeshop.rentals.service_indicator_status_report.service_status' | translate }}
                <span *ngIf="sortColumn === 'serviceStatus'" class="sort-icon">
                  {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
              </th>
              <th (click)="sort('lastServiceDate')">
                {{ 'bikeshop.rentals.service_indicator_status_report.last_service' | translate }}
                <span *ngIf="sortColumn === 'lastServiceDate'" class="sort-icon">
                  {{ sortDirection === 'asc' ? '▲' : '▼' }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData" (click)="showProduct(item)">
              <td style="padding-left:16px;">{{ item.brand }} {{ item.model }}</td>
              <td>{{ item.size }}</td>
              <td>{{ item.serialNumber }}</td>
              <td>{{ item.serviceIndicatorName }}</td>
              <td>{{ item.component || ('bikeshop.rentals.service_indicator_status_report.not_applicable' | translate) }}</td>
              <td>{{ item.metric }}</td>
              <td>
                <div class="status-container">
                  <div class="status-bar">
                    <div 
                      class="status-fill" 
                      [ngClass]="getStatusClass(item.serviceStatus)"
                      [style.width.%]="getStatusPercentage(item.serviceStatus)"
                    ></div>
                  </div>
                  <span class="status-text">
                    <!-- {{ item.totalPointsAccumulated.toFixed(0) }} {{ 'bikeshop.rentals.service_indicator_status_report.of' | translate }} {{ item.threshold }} =  -->
                    {{item.serviceStatus.toFixed(1)}}%</span>
                </div>
              </td>
              <td>{{ formatDate(item.lastServiceDate) }}</td>
            </tr>
          </tbody>
        </table>
    
        <div *ngIf="filteredData.length === 0 && reportData.length > 0" class="no-results">
          {{ 'bikeshop.rentals.service_indicator_status_report.no_search_results' | translate }}
        </div>
        <div *ngIf="reportData.length === 0 && !loadingData" class="no-results">
          {{ 'bikeshop.rentals.service_indicator_status_report.no_data' | translate }}
        </div>
      </div>
    </div>
  </div>

<p-sidebar #AddEditRentalProduct [(visible)]="showRentalProduct" position="right" [autoZIndex]="false" [baseZIndex]="0"
  [showCloseIcon]="false" [style]="{width:'700px', background: '#F6F6F8', 'overflow-x': 'auto','z-index': '1001'}"
  (onHide)="AddEditRentalProduct.destroyModal();getServiceIndicatorStatusReport(true)">
  <div *ngIf="showRentalProduct">
    <app-add-edit-rental-product [product]="selectedProductEdit" [cloneProduct]="false" [messageService]="messageService"
      (close)="closeRentalProduct()"></app-add-edit-rental-product>
  </div>
</p-sidebar>

<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>